import { Prettify } from "./prettify";

export type OnlyPropertiesName<T> = Prettify<
    Partial<{
        [P in keyof Required<T>]: Required<T>[P] extends Array<any>
            ? any
            : Required<T>[P] extends object
              ? Prettify<OnlyPropertiesName<Required<T>[P]>>
              : NonNullable<any>;
    }>
>;
